import { FieldComponent } from '@core/blocks/edu-flow-2/utils/fieldTypeDictionary';
import useRoundFieldsTest from '@core/hooks/RoundFieldsTest/useRoundFieldsTest';
import cn from '@core/utils/classNames';

import styles from './CalloutField.module.css';

const CalloutField: FieldComponent = ({ field: { heading, content } }) => {
  const { lgRounded } = useRoundFieldsTest();
  return (
    <div data-testid="callout-field" className={cn(content ? styles.callout : styles.calloutEmpty, lgRounded)}>
      {heading && <b dangerouslySetInnerHTML={{ __html: heading }} />}
      {/* if there is content and no value from preamp */}
      {content && <p dangerouslySetInnerHTML={{ __html: content }} />}
    </div>
  );
};

export default CalloutField;
